import Swiper from "swiper";

/**
 * コモンクラス
 * @constructor
 */
class Slider {
    constructor() {

    }
    /**
     * コモン
     */
    init() {
        var swiper_top = {
            autoplay: {
            delay: 4000,
            disableOnInteraction: false
            },
            loop: true,
            speed: 400,
            slidesPerView: 1,
            spaceBetween: 0,
            // navigation: {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
            pagination: {
                el: '.m-slide__pagination', //ページネーションの要素
                type: 'bullets', //ページネーションの種類
                clickable: true, //クリックに反応させる
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            }
        }

        var swiper_sec = {
            // autoplay: {
            // delay: 4000,
            // disableOnInteraction: false
            // },
            loop: false,
            speed: 400,
            slidesPerView: 4,
            // spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next2',
                prevEl: '.swiper-button-prev2',
            },
            pagination: {
                el: '.m-slideSec__pagination', //ページネーションの要素
                type: 'bullets', //ページネーションの種類
                clickable: true, //クリックに反応させる
            },
            breakpoints: {
                768: {
                    loop: false,
                    slidesPerGroup: 2,
                    slidesPerView: 2,
                    spaceBetween: 15,
                }
            }
        }

        var swiper_te = {
            // autoplay: {
            // delay: 4000,
            // disableOnInteraction: false
            // },
            loop: true,
            speed: 400,
            slidesPerView: 4,
            // spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next3',
                prevEl: '.swiper-button-prev3',
            },
            pagination: {
                el: '.m-slideTe__pagination', //ページネーションの要素
                type: 'bullets', //ページネーションの種類
                clickable: true, //クリックに反応させる
            },
            breakpoints: {
                768: {
                    slidesPerGroup: 2,
                    slidesPerView: 2,
                    spaceBetween: 15
                }
            }
        }

        $(window).on("load", function () {
            var swiperTop = new Swiper('.swiper_top', swiper_top);
            var swiperSec = new Swiper('.swiper_sec', swiper_sec);
            var swiperSec = new Swiper('.swiper_te', swiper_te);
        });

    }

}

export default Slider;
